import { type ComponentRef, forwardRef } from "react";

import {
  Button as BaseButton,
  type ButtonProps as BaseButtonProps,
} from "@radix-ui/themes";

import { semanticColor as semanticColorMapper } from "../styles";
import { cn } from "../util.cn";

interface ButtonProps extends Omit<BaseButtonProps, "variant"> {
  semanticColor?: keyof typeof semanticColorMapper;
  variant?: "inline-ghost" | BaseButtonProps["variant"];
}
type ButtonRef = ComponentRef<typeof BaseButton>;

const Button = forwardRef<ButtonRef, ButtonProps>((props, ref) => {
  const {
    variant,
    color,
    semanticColor,
    className,
    ...buttonProps
  } = props;
  const buttonVariant = variant === "inline-ghost" ? "ghost" : variant;

  return (
    <BaseButton
      {...buttonProps}
      className={cn(
        variant === "inline-ghost" && `
          hotfix--inline-button-ghost
        `,
        className,
      )}
      ref={ref}
      variant={buttonVariant}
      color={(semanticColor && semanticColorMapper[semanticColor]) || color}
    />
  );
});
Button.displayName = BaseButton.displayName;

export { Button, type ButtonProps };
